import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import { Layout as DashboardLayout } from 'src/layouts/setting';
import Loader from 'src/pages/components/loader';

const PnbListPage = lazy(() => import('src/pages/bankAutomation/pnb/pnbList'));
const PnbCreatePage = lazy(() => import('src/pages/bankAutomation/pnb/createPnb'));

export const bankAutomationRoutes = [
  {
    path: 'bankAutomation',
    element: (
      <DashboardLayout>
        <Suspense fallback={<Loader />}>
          <Outlet />
        </Suspense>
      </DashboardLayout>
    ),
    children: [
      {
        path: 'pnb',
        children: [
          {
            index: true,
            element: <PnbListPage />,
          },
          {
            path: 'create',
            element: <PnbCreatePage />,
          },
        ],
      },
    ],
  },
];
